import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Segment, Header, Modal, Button, Icon, Label, Dropdown } from "semantic-ui-react";
import PushBackForm from "./PushBackForm";
import CompleteCase from "../../../../../../models/CompleteCase";
import InvestigationCard, { InvestigationCardInputValue, } from "./InvestigationCard";
import AllocatedClaimAnalyst from "../../../../../../models/AllocatedClaimAnalyst";
import CaseRepository, { PerformQualityCheckRequestObject, } from "../../../../../../common/repository/CaseRepository";
import Result from "../../../../../../common/repository/Result";
import { toast } from "../../../../../common/Toast";
import QCData from "../../../../../../models/QCData";
import FilesPopup from "../../FilesPopup";
import URLResource from "../../../../../../models/URLResource";
import RequirePermission from "../../../../../base/RequirePermission";
import permissions from "../../../../../../common/permissions";
import GradingCard, { GradingCardInputValue } from "../ActionGrading/GradingCard";
import constants from "../../../../../../common/constants";
import LocalStorage from "../../../../../../lib/LocalStorage";
import config from "../../../../../../common/repository/config";
import { Table } from "semantic-ui-react";
import CaseFormInputDate from "../../../CaseFormInputDate";

interface Props {
  model: CompleteCase;
  updateModel?(c: CompleteCase): void;
}

interface State {
  loading: boolean;
  pushbackModalOpen: boolean;
  pushback: string;
  repudiationEvidencePopupOpen: boolean;
  qcData: QCData | null;
  values: InvestigationCardInputValue[];
  isPushbackFromCA: boolean,
  isPushbackFromRW: boolean
  editReportModalOpen?: boolean;
  reportHtml?: string;
  case_insured_dob? : string;
  qc_insured_dob?: string;
  editSource?: boolean;
  openDobModal?: boolean;
  dobUpdating?: boolean;
  originalHasDoctype?: boolean;
  reportEditLocked?: boolean;
  headerDataUrl?: string;
  signatureDataUrl?: string;

}

class ActionQualityCheck extends Component<Props, State> {
  private caseRepo = new CaseRepository();
  private portalRoot: HTMLElement | null = null;
  private reportIframeRef: React.RefObject<HTMLIFrameElement> = React.createRef();

  constructor(props: Props) {
    super(props);
    this.state = {
      loading: false,
      pushbackModalOpen: false,
      pushback: "",
      isPushbackFromCA: false,
      isPushbackFromRW: false,
      repudiationEvidencePopupOpen: false,
      qcData: null,
      values: [],
      editReportModalOpen: false,
      reportHtml: "",
      editSource: false,
      reportEditLocked: false,
      case_insured_dob: this.props.model.getDob() || "",
      qc_insured_dob: "",
      openDobModal: false,
      dobUpdating: false,
      // headerDataUrl: "",
      // signatureDataUrl: "",
    };
  }

  componentDidMount() {
    this.getQCData();
    this.checkPushbackStatus();
    this.portalRoot = document.getElementsByTagName("body")[0];
    try {
      const key = this.getReportEditLockKey();
      const locked = LocalStorage.get(key);
      if (locked === "true") {
        this.setState({ reportEditLocked: true });
      }
    } catch (_) {}
    this.preloadHeaderImage();
    this.preloadSignatureImage();
  }
  private preloadHeaderImage = async () => {
    try {
      const res = await fetch('/header.png', { cache: 'force-cache' });
      if (!res.ok) return;
      const blob = await res.blob();
      const reader = new FileReader();
      reader.onloadend = () => {
        const dataUrl = typeof reader.result === 'string' ? reader.result : '';
        if (dataUrl) this.setState({ headerDataUrl: dataUrl });
      };
      reader.readAsDataURL(blob);
    } catch (_) {}
  };

  private handleDobChange =  async () => {
    try {
      this.setState({dobUpdating: true});
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        toast.error("Authentication token is missing.");
        return
      }
      let updateDob = await fetch(`${config.apiBaseURL}/case/updateDob`, {
        method: "POST",
        headers: { 
          "x-access-token": token,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          caseId: this.props.model.getId(),
          dob: this.state.qc_insured_dob
        })
      });

      let response =  await updateDob.json();
      toast.success(response.message);
      this.setState(
        {openDobModal: false, case_insured_dob: this.state.qc_insured_dob}
      );

    } catch (e) {
      toast.error(e as string);
    } finally {
      this.setState({dobUpdating: false});
    }
  }

  private preloadSignatureImage = async () => {
    try {
      const res = await fetch('/signature.jpeg', { cache: 'force-cache' });
      if (!res.ok) return;
      const blob = await res.blob();
      const reader = new FileReader();
      reader.onloadend = () => {
        const dataUrl = typeof reader.result === 'string' ? reader.result : '';
        if (dataUrl) this.setState({ signatureDataUrl: dataUrl });
      };
      reader.readAsDataURL(blob);
    } catch (_) {}
  };


  getQCData = () => {
    this.setState({ loading: true }, async () => {
      const { model } = this.props;
      const result = await this.caseRepo.getQCData({ case_id: model.getId() });

      if (result instanceof Result.Success) {
        const qcData = result.data;
        const values = qcData
          .getAllocations()
          .map((it, i) => this.mapAllocatedClaimAnalystToValue(`${i}`, it));
        this.setState({ loading: false, values, qcData });
      } else {
        this.setState({ loading: false }, () => {
          const message = result.message || "Something went wrong";
          toast.error(message);
        });
      }
    });
  };

  private injectHeaderIntoHtml = (html: string): string => {
    try {
      if (!html) return html;
      if (html.includes('id="jd-report-header"') || html.includes('alt="Header"')) return html;
      const headerSrc = this.state.headerDataUrl || '/header.png';
      const signSrc = this.state.signatureDataUrl || '/header.png';
      console.log(signSrc,"signSrc")
      const cssOnce = `<style data-jd-header="true">\n  #jd-report-header{padding:8px 0 12px 0;text-align:right;width:100%;box-sizing:border-box;}\n  #jd-report-header img{display:block;margin:0 auto;max-width:100%;height:auto;max-height:140px;object-fit:contain;}\n  @media print{#jd-report-header{page-break-after:avoid;}}\n</style>`;
      const needsCss = !/data-jd-header=\"true\"/.test(html);
      const styleBlock = needsCss ? cssOnce : '';
            const signCssOnce = `<style data-jd-footer="true">\n  #jd-report-footer{margin-top:40px;padding:20px 0;text-align:left;}\n  #jd-report-footer .closing-text{margin-bottom:20px;font-size:14px;line-height:1.6;font-weight:bold;}\n  #jd-report-footer .signature-section{text-align:left;}\n  #jd-report-footer .signature-section img{max-width:200px;height:auto;max-height:80px;object-fit:contain;}\n  #jd-report-footer .signature-name{margin-top:10px;font-weight:bold;}\n  @media print{#jd-report-footer{page-break-before:avoid;}}\n</style>`;
      const signNeedsCss = !/data-jd-footer=\"true\"/.test(html);
      const signBlock = needsCss ? cssOnce : '';
      const headerBlock = `${styleBlock}<div id="jd-report-header">
          <img src="${headerSrc}" alt="Header" textAlign="right"/>
        </div>`;
              const footerBlock = `${signBlock}<div id="jd-report-footer">
          <div class="closing-text">
            Thanking you,<br>
            Yours truly
          </div>
          <div class="signature-section">
            <img src="${signSrc}" alt="Signature"/>
            <div class="signature-name">
              Dr. Gurpreet Singh<br>
              Authorized Signatory
            </div>
          </div>
        </div>`;
    if (/<body[^>]*>/i.test(html) && /<\/body>/i.test(html)) {
      return html
        .replace(/<body([^>]*)>/i, `<body$1>${headerBlock}`)
        .replace(/<\/body>/i, `${footerBlock}</body>`);
    }
      return `${headerBlock}${html}`;
    } catch (_) {
      return html;
    }
  };


 
  private clearReportEditLock = () => {
    try {
      const key = this.getReportEditLockKey();
      LocalStorage.remove(key);
      this.setState({ reportEditLocked: false });
    } catch (_) {}
  };

  private viewReportWithHeader = async () => {
    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
    if (!token) {
      toast.error("Authentication token is missing.");
      return;
    }
    try {
      this.setState({ loading: true });
      if (!this.state.headerDataUrl) await this.preloadHeaderImage();
      if (!this.state.signatureDataUrl) await this.preloadSignatureImage();
      const response = await fetch(`${config.apiBaseURL}/case/getReport`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({ caseId: this.props.model.getId() }),
      });
      const result = await response.json();
      if (response.ok && (result.success === true || result.success === "true") && result.data && (result.data.items || result.data.html)) {
        const fullHtml = result.data.items || result.data.html;
        const withHeader = this.injectHeaderIntoHtml(fullHtml);
        const w = window.open('', '_blank');
        if (w) {
          w.document.open();
          w.document.write(withHeader);
          w.document.close();
        }
      } else {
        toast.error(result.message || 'Failed to fetch report.');
      }
    } catch (e) {
      console.error(e);
      toast.error('Error opening report');
    } finally {
      this.setState({ loading: false });
    }
  };

  fetchReportHtml = async () => {
    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
    if (!token) {
      toast.error("Authentication token is missing.");
      return;
    }

    try {
      this.setState({ loading: true });
      if (!this.state.headerDataUrl) await this.preloadHeaderImage();
      if (!this.state.signatureDataUrl) await this.preloadSignatureImage();

      const response = await fetch(`${config.apiBaseURL}/case/getReport`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({ caseId: this.props.model.getId() }),
      });

      const result = await response.json();

      if (response.ok && (result.success === true || result.success === "true") && result.data && (result.data.items || result.data.html)) {
        const fullHtml = result.data.items.htmlData || result.data.html;
        let htmlWithHeader = this.injectHeaderIntoHtml(fullHtml);
        const hasDoctype = /^\s*<!DOCTYPE/i.test(htmlWithHeader);
        this.setState({
          reportHtml: htmlWithHeader,
          editReportModalOpen: true,
          editSource: false,
          originalHasDoctype: hasDoctype,
        });
      } else {
        toast.error(result.message || "Failed to fetch report.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error fetching report.");
    } finally {
      this.setState({ loading: false });
    }
  };

  private inlineProtectedImages = async (html: string, token: string): Promise<string> => {
    try {
      if (!html) return html;
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const images = Array.from(doc.getElementsByTagName('img')) as HTMLImageElement[];

      const isDataUrl = (src: string) => /^data:/i.test(src);
      const shouldInline = (src: string) => {
        if (!src || isDataUrl(src)) return false;
        if (src.endsWith('/header.png') || src === '/header.png') return false;
        try {
          const url = new URL(src, window.location.origin);
          const apiBase = new URL(config.apiBaseURL);
          return url.host === apiBase.host || src.startsWith('/') || /\/uploads\//i.test(src);
        } catch (_) {
          return true;
        }
      };

      const fetchAsDataUrl = async (urlStr: string): Promise<string | null> => {
        try {
          const absolute = new URL(urlStr, config.apiBaseURL).toString();
          const res = await fetch(absolute, {
            headers: { 'x-access-token': token, 'Accept': 'image/*' },
          });
          if (!res.ok) return null;
          const blob = await res.blob();
          const mime = blob.type || '';
          if (/emf/i.test(urlStr) || /emf/i.test(mime)) {
            const pngUrl = urlStr.replace(/\.emf(\?.*)?$/i, '.png$1');
            if (pngUrl !== urlStr) {
              const pngData = await fetchAsDataUrl(pngUrl);
              if (pngData) return pngData;
            }
            const jpgUrl = urlStr.replace(/\.emf(\?.*)?$/i, '.jpg$1');
            if (jpgUrl !== urlStr) {
              const jpgData = await fetchAsDataUrl(jpgUrl);
              if (jpgData) return jpgData;
            }
          }
          return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(typeof reader.result === 'string' ? reader.result : null);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        } catch (_) {
          return null;
        }
      };

      await Promise.all(images.map(async (img) => {
        const src = img.getAttribute('src') || '';
        if (!shouldInline(src)) return;
        const dataUrl = await fetchAsDataUrl(src);
        if (dataUrl) img.setAttribute('src', dataUrl);
      }));

      const elements = Array.from(doc.querySelectorAll('[style]')) as HTMLElement[];
      await Promise.all(elements.map(async (el) => {
        const style = el.getAttribute('style') || '';
        const match = style.match(/background-image:\s*url\((['\"]?)([^)'\"]+)\1\)/i);
        if (!match) return;
        const url = match[2];
        if (!shouldInline(url)) return;
        const dataUrl = await fetchAsDataUrl(url);
        if (dataUrl) {
          const newStyle = style.replace(match[0], `background-image: url(${dataUrl})`);
          el.setAttribute('style', newStyle);
        }
      }));

      const doctype = /^\s*<!DOCTYPE[\s\S]*?>/i.exec(html)?.[0] || '';
      const serialized = '<html>' + doc.documentElement.innerHTML + '</html>';
      return (doctype ? doctype + '\n' : '') + serialized;
    } catch (_) {
      return html;
    }
  };

  private setIframeEditable = (editable: boolean) => {
    try {
      const iframe = this.reportIframeRef.current;
      if (!iframe) return;
      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!doc) return;
      try {
        (doc as any).designMode = editable ? 'on' : 'off';
      } catch (e) {
        if (doc.body) (doc.body as any).contentEditable = editable ? 'true' : 'false';
      }
    } catch (e) {
  
    }
  };

  private pullHtmlFromIframe = (): string | null => {
    try {
      const iframe = this.reportIframeRef.current;
      if (!iframe) return null;
      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!doc) return null;
      return doc.documentElement.outerHTML;
    } catch (e) {
      return null;
    }
  };

  private getIframeDocument = (): Document | null => {
    try {
      const iframe = this.reportIframeRef.current;
      if (!iframe) return null;
      return iframe.contentDocument || iframe.contentWindow?.document || null;
    } catch (e) {
      return null;
    }
  };

  private getSelectionInIframe = (): Selection | null => {
    const doc = this.getIframeDocument();
    if (!doc) return null;
    try {
      return doc.getSelection ? doc.getSelection() : (doc as any).selection;
    } catch (e) {
      return null;
    }
  };

  private findAncestorByTag = (node: Node | null, tagName: string): HTMLElement | null => {
    let current: Node | null = node;
    const target = tagName.toUpperCase();
    while (current) {
      if ((current as HTMLElement).tagName && (current as HTMLElement).tagName.toUpperCase() === target) {
        return current as HTMLElement;
      }
      current = current.parentNode;
    }
    return null;
  };

  private getActiveCell = (): HTMLTableCellElement | null => {
    const sel = this.getSelectionInIframe();
    if (!sel || sel.rangeCount === 0) return null;
    const range = sel.getRangeAt(0);
    const container = range.startContainer as Node;
    const cell = this.findAncestorByTag(container, 'td') as HTMLTableCellElement | null
      || this.findAncestorByTag(container, 'th') as HTMLTableCellElement | null;
    return cell || null;
  };

  private getActiveTable = (): HTMLTableElement | null => {
    const cell = this.getActiveCell();
    if (!cell) return null;
    const table = this.findAncestorByTag(cell, 'table') as HTMLTableElement | null;
    return table;
  };

  private addRowBelow = () => {
    const cell = this.getActiveCell();
    if (!cell) { toast.error('Place cursor inside a table to add a row'); return; }
    const row = cell.parentElement as HTMLTableRowElement;
    const table = this.getActiveTable();
    if (!row || !table) return;
    const newRow = row.cloneNode(true) as HTMLTableRowElement;
    Array.from(newRow.cells).forEach((c) => { c.innerHTML = '&nbsp;'; });
    row.parentElement?.insertBefore(newRow, row.nextSibling);
  };

  private addRowAbove = () => {
    const cell = this.getActiveCell();
    if (!cell) { toast.error('Place cursor inside a table to add a row'); return; }
    const row = cell.parentElement as HTMLTableRowElement;
    const newRow = row.cloneNode(true) as HTMLTableRowElement;
    Array.from(newRow.cells).forEach((c) => { c.innerHTML = '&nbsp;'; });
    row.parentElement?.insertBefore(newRow, row);
  };

  private addColumnRight = () => {
    const cell = this.getActiveCell();
    if (!cell) { toast.error('Place cursor inside a table to add a column'); return; }
    const table = this.getActiveTable();
    if (!table) return;
    const colIndex = cell.cellIndex + 1;
    Array.from(table.rows).forEach((r) => {
      const ref = r.cells[cell.cellIndex] || r.cells[r.cells.length - 1];
      const newCell = (ref.tagName.toLowerCase() === 'th' ? document.createElement('th') : document.createElement('td')) as HTMLTableCellElement;
      newCell.innerHTML = '&nbsp;';
      if (colIndex >= r.cells.length) {
        r.appendChild(newCell);
      } else {
        r.insertBefore(newCell, r.cells[colIndex]);
      }
    });
  };

  private addColumnLeft = () => {
    const cell = this.getActiveCell();
    if (!cell) { toast.error('Place cursor inside a table to add a column'); return; }
    const table = this.getActiveTable();
    if (!table) return;
    const colIndex = cell.cellIndex;
    Array.from(table.rows).forEach((r) => {
      const ref = r.cells[colIndex] || r.cells[0];
      const newCell = (ref.tagName.toLowerCase() === 'th' ? document.createElement('th') : document.createElement('td')) as HTMLTableCellElement;
      newCell.innerHTML = '&nbsp;';
      r.insertBefore(newCell, ref);
    });
  };

  private execInIframe = (command: string, value?: string) => {
    try {
      const doc = this.getIframeDocument();
      if (!doc) return;

      try { (doc as any).designMode = 'on'; } catch(_) {}
      doc.execCommand(command, false, value);
    } catch (_) {}
  };

  private applyHeading = (level: 1 | 2 | 3 | 4 | 5 | 6 | 0) => {
    if (level === 0) {
      this.execInIframe('formatBlock', 'P');
    } else {
      this.execInIframe('formatBlock', `H${level}`);
    }
  };

  private promptAndCreateLink = () => {
    const url = window.prompt('Enter URL');
    if (url) this.execInIframe('createLink', url);
  };

  private removeLink = () => {
    this.execInIframe('unlink');
  };

  private deleteCurrentRow = () => {
    const cell = this.getActiveCell();
    if (!cell) { toast.error('Place cursor inside a table row to delete'); return; }
    const row = cell.parentElement as HTMLTableRowElement | null;
    const table = this.getActiveTable();
    if (!row || !table || !row.parentElement) return;
    const totalRows = table.rows.length;
    if (totalRows <= 1) { toast.error('Cannot delete the only row'); return; }
    row.parentElement.removeChild(row);
  };

  private deleteCurrentColumn = () => {
    const cell = this.getActiveCell();
    if (!cell) { toast.error('Place cursor inside a table column to delete'); return; }
    const table = this.getActiveTable();
    if (!table) return;
    const colIndex = cell.cellIndex;
    const firstRow = table.rows[0];
    if (!firstRow || firstRow.cells.length <= 1) { toast.error('Cannot delete the only column'); return; }
    Array.from(table.rows).forEach((r) => {
      if (r.cells[colIndex]) {
        r.deleteCell(colIndex);
      }
    });
  };

  private updateReport = async (html: string) => {
    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
    if (!token) {
      toast.error("Authentication token is missing.");
      return;
    }

    try {
      this.setState({ loading: true });
      if (!this.state.headerDataUrl) await this.preloadHeaderImage();
      if (!this.state.signatureDataUrl) await this.preloadSignatureImage();

      // Ensure header and footer are present in the HTML we send to server
      let htmlToSend = this.injectHeaderIntoHtml(html);
      // htmlToSend = this.injectFooterIntoHtml(htmlToSend);
      const response = await fetch(`${config.apiBaseURL}/case/updateReport`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({
          caseId: this.props.model.getId(),
          htmlReport: htmlToSend,
        }),
      });

      const result = await response.json();

      if (response.ok && (result.success === true || result.success === "true")) {
        const returnedHtml = (result.data && (result.data.items || result.data.html)) || html;
        // Persist a one-time lock to disable further edits
        try {
          const key = this.getReportEditLockKey();
          LocalStorage.set(key, "true");
        } catch (_) {}
        this.setState({ reportHtml: returnedHtml, editReportModalOpen: false, reportEditLocked: true }, () => {
          toast.success("Report updated successfully");
        });
      } else {
        toast.error(result.message || "Failed to update report.");
      }
    } catch (e) {
      console.error(e);
      toast.error("Error updating report.");
    } finally {
      this.setState({ loading: false });
    }
  };

  private getReportEditLockKey = (): string => {
    try {
      const caseId = this.props.model.getId();
      return `__jdhealthcare__report_edit_locked_${caseId}`;
    } catch (_) {
      return `__jdhealthcare__report_edit_locked_unknown`;
    }
  };

  mapAllocatedClaimAnalystToValue = (
    fakeId: string,
    allocatedClaimAnalyst: AllocatedClaimAnalyst
  ) => {
    const value = { ...InvestigationCard.initialValue };

    value.id = fakeId;
    value.claimAnalystId = allocatedClaimAnalyst.getClaimAnalyst().getId();
    const investigators = allocatedClaimAnalyst
      .getAllocatedInvestigators()
      .map((it) => {
        const id = it.getInvestigator().getId();
        const allocationId = it.getId();
        const casePortion = it.getCasePortion();
        const investigationOutcome = it.getOutcome();
        const investigationLocation = it.getInvestigationLocation();
        const allowance = it.getAllowance();
        const documentExpense = it.getDocumentExpense();
        const extraExpense = it.getExtraExpense();
        const approvedExpense = it.getApprovedExpense();

        let capping = "";
        if (casePortion !== null) capping = casePortion.toString();

        let outcome = "";
        if (investigationOutcome !== null) outcome = investigationOutcome;
        return {
          id,
          allocationId,
          capping,
          outcome,
          investigationLocation,
          allowance,
          documentExpense,
          extraExpense,
          approvedExpense,
        };
      });

    value.investigators = investigators;
    return value;
  };

  onChange = (value: InvestigationCardInputValue | GradingCardInputValue) => {
    const values = this.state.values;
    const i = values.findIndex((it) => it.id === value.id);
    if (i === -1) return;
    values[i] = value;
    this.setState({ values: [...values] });
  };

  private  handleCompare = (value: string) => {
    if(this.state.case_insured_dob !== value) {
      this.setState({ openDobModal: true })
    } else {
       this.setState({ openDobModal: false})
       toast.success("Dob Verified");
    }
  }

  disbableSubmitButton = () => {
    if (this.state.loading) return true;

    if (this.state.qcData === null) return true;

    let disable = false;
    this.state.values.forEach((it) => {
      it.investigators.forEach((inv) => {
        if (inv.capping === "") disable = true;
      });
    });
    return disable;
  };

  onSubmit = () => {
    this.setState({ loading: true }, async () => {
      const { model, updateModel } = this.props;
      const ro: PerformQualityCheckRequestObject = {
        case_id: model.getId(),
        type: constants.roleTitle.ca,

        allocations: this.state.values.map((it) => {
          return {
            head_id: it.claimAnalystId,
            team: it.investigators.map((inv) => ({
              allocation_id: inv.allocationId,
              investigator_id: inv.id,
              case_portion: inv.capping,
              outcome: inv.outcome,
              allowance: inv.allowance,
              investigation_location: {
                state: inv.investigationLocation?.getState(),
                district: inv.investigationLocation?.getDistrict(),
              },
              document_expense: inv.documentExpense,
              extra_expense: inv.extraExpense,
              approved_expense: inv.approvedExpense,
            })),
            grade_report: {
              allocation_hygiene: it.allocationHygiene,
              report_quality: it.reportQuality,
              outcome: it.outcome,
              tat: it.tat,
            },
            feedback: it.feedback,
          };
        }),
      };

      const result = await this.caseRepo.performQualityCheck(ro);
      if (result instanceof Result.Success) {
        this.setState({ loading: false }, () => {
          const c = result.data as unknown as CompleteCase;
          toast.success("Successfully performed QC");
          if (updateModel) updateModel(c);
        });
      } else {
        this.setState({ loading: false }, () => {
          const message = result.message || "Something went wrong";
          toast.error(message);
        });
      }
    });
  };

 checkPushbackStatus = async () => {
    const caseId = this.props.model.getId();
    const type = this.props.model.getType();
    const claimNumber = this.props.model.getClaimNumber();
    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);

    if (!token) {
      toast.error("Authentication token is missing.");
      return;
    }
    try {
      this.setState({ loading: true });

      const response = await fetch(`${config.apiBaseURL}/case/checkPushbackFor`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({
          caseId,
          type,
          claimNumber,
        }),
      });

      const result = await response.json();
      console.log(result, "kkk");

      if (!response.ok) {
        throw new Error(result.message || "Pushback check failed");
      }
      if (result.success === "true") {
        this.setState({
          isPushbackFromCA: true,
          isPushbackFromRW: false,
        });
        this.clearReportEditLock();
      } else if (result.success === "false") {
        this.setState({
          isPushbackFromCA: false,
          isPushbackFromRW: true,
        });
        this.clearReportEditLock();
      }
    } catch (error) {
      toast.error("An error occurred while checking pushback status.");
      console.error(error);
    } finally {
      this.setState({ loading: false });
    }
  };


  render() {
    const { model, updateModel } = this.props;

    let allocations = null;
    let grading = null;
    if (this.state.qcData !== null) {
      allocations = this.state.qcData.getAllocations().map((it, i) => {
        return (
          <InvestigationCard
            key={i}
            model={it}
            value={this.state.values.find((v) => v.id === `${i}`)!}
            onChange={this.onChange}
            newData={model}
          />
        );
      });
      grading = this.state.qcData.getAllocations().map((it, i) => {
        return (
          <GradingCard
            key={i}
            model={it}
            value={this.state.values.find((v) => v.id === `${i}`)!}
            onChange={this.onChange}
          />
        );
      });
    }
    let report: any = null;
    if (this.state.qcData !== null) report = this.state.qcData.getReport();

    let currentReport: any = null;
    if (report!== null) currentReport = report[report.length - 1];



    let queryTriggerDocument = null;
    if (this.state.qcData !== null) queryTriggerDocument = this.state.qcData.getQueryTriggerDocument();


    let repudiationEvidence: URLResource[] = [];
    if (this.state.qcData !== null)
      repudiationEvidence = this.state.qcData.getRepudiationEvidences();


    let ReinvestigationReport = null;
    let ReinvestigationFilalReports = null;
    let ReinvestigationRepudiationEvidence: any[] = [];
    let ReinvestigationQueryTriggerDocument = null;

    if (this.props.model.getReinvestigation()) {
      if (report!== null) ReinvestigationReport = report[report.length - 2];

      ReinvestigationFilalReports = this.props.model.getFinalReport();
      
      if (model.getRepudiationEvidence())
        ReinvestigationRepudiationEvidence = this.props.model.getRepudiationEvidence();

      if (this.props.model.getQueryTriggerDocument() !== null) ReinvestigationQueryTriggerDocument = this.props.model.getQueryTriggerDocument();
    }




    return (
      <Segment basic loading={this.state.loading}>


        {this.props.model.getReinvestigation() && <div>
          <Header as="h3">
            Re-investigation Reports
          </Header>
          {/* report */}
          <Button
            as="a"
            href={ReinvestigationReport && ReinvestigationReport.getURL()}
            disabled={ReinvestigationReport === null}
            target="_blank"
            icon
            primary
            labelPosition="left"
            size="tiny"
          >
            <Icon name="file alternate outline" />
            View Report
          </Button>
          {/* report */}

          {/* repudiation evidence */}
          {model.getOutcome() == "Repudiation" && <Button
            icon
            primary
            labelPosition="left"
            size="tiny"
            disabled={
              this.state.repudiationEvidencePopupOpen ||
              ReinvestigationRepudiationEvidence.length === 0
            }
            onClick={() =>
              this.setState({ repudiationEvidencePopupOpen: true })
            }
          >
            <Icon name="file alternate outline" />
            {ReinvestigationRepudiationEvidence.length === 0
              ? "No Repudiation Evidence"
              : "View Repudiation Evidence"}
          </Button>}
          {/* repudiation evidence */}
          {/* <Label basic size={"large"} color={"blue"}>
            Case Type{" "}
            <Label.Detail>{model.getType().getTitle()}</Label.Detail>
          </Label>
          <Label basic size={"large"} color={"blue"}>
            Case Outcome <Label.Detail>{model.getOutcome()}</Label.Detail>
          </Label> */}
          {model.getRepudiationGround() && model.getOutcome() == "Repudiation" && <Label basic size={"large"} color={"blue"}>
            Repudation Ground <Label.Detail>{model.getRepudiationGround()}</Label.Detail>
          </Label>}
          {/* Final Report */}
          {
            ReinvestigationFilalReports?.getURL() !== null &&
            <Button
              as="a"
              href={ReinvestigationFilalReports && ReinvestigationFilalReports.getURL()}
              disabled={ReinvestigationFilalReports === null}
              target="_blank"
              icon
              primary
              labelPosition="left"
              size="tiny"
            >
              <Icon name="file alternate outline" />
              Final Report
            </Button>}
          {/* Repudiation Evidence */}
          {this.state.repudiationEvidencePopupOpen &&
            ReactDOM.createPortal(
              <FilesPopup
                title="Repudiation Evidence"
                onClose={() => this.setState({ repudiationEvidencePopupOpen: false })}
                files={repudiationEvidence} allocationId={model.getId()} />,
              this.portalRoot!
            )}

          {/* Query triger Document */}
          {ReinvestigationQueryTriggerDocument?.getURL() !== null && model.getOutcome() == "Inconclusive" && <Button
            as="a"
            href={ReinvestigationQueryTriggerDocument && ReinvestigationQueryTriggerDocument.getURL()}
            disabled={ReinvestigationQueryTriggerDocument === null}
            target="_blank"
            icon
            primary
            labelPosition="left"
            size="tiny"
          >
            <Icon name="file alternate outline" />
            Query Trigger Document
          </Button>}
        </div>
        }
        <Header as="h3">
          Quality Check
          {/*<Header.Subheader>*/}
          {/*    <b>Case Type:</b> {model.getType().getTitle()}*/}
          {/*    &nbsp;&nbsp;&nbsp;*/}
          {/*    <b>Case Outcome:</b> {model.getOutcome()}*/}
          {/*</Header.Subheader>*/}
        </Header>

        {/* report */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <div>
            {/* report */}
            <Button
              as="div"
              primary
              size="tiny"
              style={{ display: 'inline-flex', alignItems: 'left', cursor: 'default' }}
              title="View Report"
            >
              <span
                onClick={() => {
                  if (currentReport) window.open(currentReport.getURL(), '_blank');
                }}
                style={{ display: 'inline-flex', alignItems: 'center', flex: 1, cursor: report ? 'pointer' : 'not-allowed' }}
              >
                <Icon name="file alternate outline" />
                View Report
              </span>
              <Icon
                name="edit"
                style={{ marginLeft: 10, cursor: this.state.reportEditLocked ? 'not-allowed' : 'pointer', opacity: this.state.reportEditLocked ? 0.5 : 1 }}
                title={this.state.reportEditLocked ? 'Edit disabled after first update' : 'Edit Report'}
                onClick={(e: any) => {
                  if (this.state.reportEditLocked) {
                    e.stopPropagation();
                    toast.error("Please push case back to edit the report again");
                    return;
                  }
                  e.stopPropagation();
                  this.fetchReportHtml();
                }}
              />
            </Button>
            {/* report */}

            {/* repudiation evidence */}
            {model.getRepudiationGround() && model.getOutcome() == "Repudiation" && <Button
              icon
              primary
              labelPosition="left"
              size="tiny"
              disabled={
                this.state.repudiationEvidencePopupOpen ||
                repudiationEvidence.length === 0
              }
              onClick={() =>
                this.setState({ repudiationEvidencePopupOpen: true })
              }
            >
              <Icon name="file alternate outline" />
              {repudiationEvidence.length === 0
                ? "No Repudiation Evidence"
                : "View Repudiation Evidence"}
            </Button>}
            {/* repudiation evidence */}
            <Label basic size={"large"} color={"blue"}>
              Case Type{" "}
              <Label.Detail>{model.getType().getTitle()}</Label.Detail>
            </Label>
            <Label basic size={"large"} color={"blue"}>
              Case Outcome <Label.Detail>{model.getOutcome()}</Label.Detail>
            </Label>
            {model.getRepudiationGround() && model.getOutcome() == "Repudiation" && <Label basic size={"large"} color={"blue"}>
              Repudation Ground <Label.Detail>{model.getRepudiationGround()}</Label.Detail>
            </Label>}

            {queryTriggerDocument?.getURL() !== null && model.getOutcome() == "Inconclusive" && <Button
              as="a"
              href={queryTriggerDocument && queryTriggerDocument.getURL()}
              disabled={queryTriggerDocument === null}
              target="_blank"
              icon
              primary
              labelPosition="left"
              size="tiny"
            >
              <Icon name="file alternate outline" />
              Query Trigger Document
            </Button>}

            {this.state.repudiationEvidencePopupOpen &&
              ReactDOM.createPortal(
                <FilesPopup
                  title="Repudiation Evidence"
                  onClose={() => this.setState({ repudiationEvidencePopupOpen: false })}
                  files={repudiationEvidence} allocationId={model.getId()} />,
                this.portalRoot!
              )}

            {/* Edit Report Modal */}
            <Modal
              open={!!this.state.editReportModalOpen}
              onClose={() => this.setState({ editReportModalOpen: false })}
              closeIcon
              size="large"
            >
              <Modal.Header>Edit Report</Modal.Header>
              <Modal.Content scrolling>
                {/* Ribbon toolbar (MS Word like) - sticky top */}
                <div style={{ position: 'sticky', top: 0, zIndex: 2, background: '#fff', paddingBottom: 8, marginBottom: 10, borderBottom: '1px solid #eee' }}>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
                    <Button size="tiny" onClick={() => this.execInIframe('undo')} icon title="Undo"><Icon name="undo" /></Button>
                    <Button size="tiny" onClick={() => this.execInIframe('redo')} icon title="Redo"><Icon name="redo" /></Button>
                    <div style={{ width: 1, height: 24, background: '#ddd', margin: '0 6px' }} />
                    <Button size="tiny" onClick={() => this.execInIframe('bold')} icon title="Bold"><Icon name="bold" /></Button>
                    <Button size="tiny" onClick={() => this.execInIframe('italic')} icon title="Italic"><Icon name="italic" /></Button>
                    <Button size="tiny" onClick={() => this.execInIframe('underline')} icon title="Underline"><Icon name="underline" /></Button>
                    <Button size="tiny" onClick={() => this.execInIframe('strikeThrough')} icon title="Strikethrough"><Icon name="strikethrough" /></Button>
                    <div style={{ width: 1, height: 24, background: '#ddd', margin: '0 6px' }} />
                    <Button size="tiny" onClick={() => this.execInIframe('insertUnorderedList')} icon title="Bulleted list"><Icon name="list ul" /></Button>
                    <Button size="tiny" onClick={() => this.execInIframe('insertOrderedList')} icon title="Numbered list"><Icon name="list ol" /></Button>
                    <Button size="tiny" onClick={() => this.execInIframe('outdent')} icon title="Decrease indent"><Icon name="outdent" /></Button>
                    <Button size="tiny" onClick={() => this.execInIframe('indent')} icon title="Increase indent"><Icon name="indent" /></Button>
                    <div style={{ width: 1, height: 24, background: '#ddd', margin: '0 6px' }} />
                    <Button size="tiny" onClick={() => this.execInIframe('justifyLeft')} icon title="Align left"><Icon name="align left" /></Button>
                    <Button size="tiny" onClick={() => this.execInIframe('justifyCenter')} icon title="Align center"><Icon name="align center" /></Button>
                    <Button size="tiny" onClick={() => this.execInIframe('justifyRight')} icon title="Align right"><Icon name="align right" /></Button>
                    <Button size="tiny" onClick={() => this.execInIframe('justifyFull')} icon title="Justify"><Icon name="align justify" /></Button>
                    <div style={{ width: 1, height: 24, background: '#ddd', margin: '0 6px' }} />
                    <Button size="tiny" onClick={() => this.execInIframe('removeFormat')} title="Clear formatting">Clear</Button>
                  </div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', marginTop: 6 }}>
                    <Button size="tiny" onClick={() => this.applyHeading(0)} title="Normal">Normal</Button>
                    <Button size="tiny" onClick={() => this.applyHeading(1)} title="Heading 1">H1</Button>
                    <Button size="tiny" onClick={() => this.applyHeading(2)} title="Heading 2">H2</Button>
                    <Button size="tiny" onClick={() => this.applyHeading(3)} title="Heading 3">H3</Button>
                    <div style={{ width: 1, height: 24, background: '#ddd', margin: '0 6px' }} />
                    <Button size="tiny" onClick={() => this.execInIframe('foreColor', '#000000')} title="Font color">A</Button>
                    <Button size="tiny" onClick={() => this.execInIframe('hiliteColor', '#ffff00')} title="Highlight">HL</Button>
                    <div style={{ width: 1, height: 24, background: '#ddd', margin: '0 6px' }} />
                    <Button size="tiny" onClick={() => this.promptAndCreateLink()} icon title="Insert link"><Icon name="linkify" /></Button>
                    <Button size="tiny" onClick={() => this.removeLink()} icon title="Remove link"><Icon name="unlinkify" /></Button>
                    <div style={{ width: 1, height: 24, background: '#ddd', margin: '0 6px' }} />
                    <Dropdown text='Table' size='tiny' pointing className='link item' style={{ padding: 0 }}>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={this.addRowAbove}><Icon name='arrow up' /> Insert row above</Dropdown.Item>
                        <Dropdown.Item onClick={this.addRowBelow}><Icon name='arrow down' /> Insert row below</Dropdown.Item>
                        <Dropdown.Item onClick={this.addColumnLeft}><Icon name='arrow left' /> Insert column left</Dropdown.Item>
                        <Dropdown.Item onClick={this.addColumnRight}><Icon name='arrow right' /> Insert column right</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={this.deleteCurrentRow}><Icon name='close' color='red' /> Delete row</Dropdown.Item>
                        <Dropdown.Item onClick={this.deleteCurrentColumn}><Icon name='close' color='red' /> Delete column</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
                {this.state.reportHtml ? (
                  <iframe
                    title="Report Editor"
                    style={{ width: '100%', height: '70vh', border: '1px solid #ccc' }}
                    ref={this.reportIframeRef}
                    srcDoc={this.state.reportHtml || ''}
                    onLoad={() => {
                      // Start editable immediately
                      this.setIframeEditable(true);
                    }}
                  />
                ) : (
                  <p>No report available</p>
                )}
              </Modal.Content>
              <Modal.Actions>
                <Button
                  primary
                  onClick={() => {
                    let htmlToSave = this.state.reportHtml || '';
                    if (!this.state.editSource) {
                      const html = this.pullHtmlFromIframe();
                      if (html) htmlToSave = html;
                    }
                    // Ensure a DOCTYPE is present for backend MHTML processing
                    const hasDoctype = /^\s*<!DOCTYPE/i.test(htmlToSave);
                    if (!hasDoctype) {
                      htmlToSave = '<!DOCTYPE html>' + (htmlToSave.startsWith('\n') ? '' : '\n') + htmlToSave;
                    }
                    this.updateReport(htmlToSave);
                  }}
                >
                  Save
                </Button>
                <Button onClick={() => this.setState({ editReportModalOpen: false })}>
                  Close
                </Button>
              </Modal.Actions>
            </Modal>
          </div>

          {/* Push Back Modal */}
          <Modal
            open={this.state.pushbackModalOpen}
            onClose={() => this.setState({ pushbackModalOpen: false })}
            size="tiny"
            closeOnDimmerClick={false}
            closeOnEscape={false}
            closeIcon
            trigger={
              <RequirePermission permission={permissions.Case.pushback}>
                <Button
                  icon
                  negative
                  labelPosition="left"
                  disabled={this.state.isPushbackFromRW}
                  onClick={() => this.setState({ pushbackModalOpen: true, pushback: constants.roleTitle.ca })}
                >
                  <Icon name="ban" />
                  Push Back For CA
                </Button>


                <Button
                  icon
                  negative
                  labelPosition="left"
                  disabled={this.state.isPushbackFromCA}
                  onClick={() => this.setState({ pushbackModalOpen: true, pushback: constants.roleTitle.rw })}
                >
                  <Icon name="ban" />
                  Push Back For RW
                </Button>
              </RequirePermission>
            }
          >
            <Modal.Header>Push Back</Modal.Header>
            <Modal.Content>
              <PushBackForm
                model={this.props.model}
                onSuccess={(it) => {
                  this.setState({ pushbackModalOpen: false });
                  if (updateModel) updateModel(it as CompleteCase);
                }}
                pushback={this.state.pushback}
              />
            </Modal.Content>
          </Modal>
          {/* Push Back Modal */}
        </div>
        <>
              <Table striped compact celled structured>
                <Table.Body style={{ fontWeight: 500 }}>
                  <Table.Row style={{backgroundColor: "#2185d0"}}>
                    <Table.Cell colSpan={2} >
                      <h3 style={{color:"white"}}> Change Insured Details</h3>
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row style={{paddinTop:"20px", paddinBottom:"20px"}}>
                    <Table.Cell>Insured DOB</Table.Cell>
                    {/* <Table.Cell>
                      <CaseFormInputDate
                        required = {true}
                        labelWidth='150px'
                        value={this.state.qc_insured_dob || ""}
                        onChange={(value) => {
                            this.setState({ qc_insured_dob: value });
                          }}
                        label=''
                        placeholder='Pick Date of Birth' />
                      <Button
                        primary
                        size="small"
                        style={{
                          marginTop: "8px",
                          width: "100%",
                          borderRadius: "6px"
                        }}
                        onClick={() => this.handleCompare(this.state.qc_insured_dob!)}
                      >
                        Verify DOB
                      </Button>
                    </Table.Cell> */}
                    <Table.Cell>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px"
                        }}
                      >
                        <CaseFormInputDate
                          required={true}
                          labelWidth="150px"
                          value={this.state.qc_insured_dob || ""}
                          onChange={(value) => {
                            this.setState({ qc_insured_dob: value });
                          }}
                          label=""
                          placeholder="Pick Date of Birth"
                        />

                        <Button
                          primary
                          size="small"
                          onClick={() =>
                            this.handleCompare(this.state.qc_insured_dob!)
                          }
                          style={{
                            height: "38px",
                            marginTop: "0px",
                            borderRadius: "4px"
                          }}
                        >
                          <Icon name="check" />
                          Verify DOB
                        </Button>
                      </div>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>      
        </>
        <Modal
          open={this.state.openDobModal}
          closeIcon
          closeOnDimmerClick={false}
          closeOnEscape={true}
          onClose={() => this.setState({openDobModal: false, qc_insured_dob: ""})}
        >
          <Modal.Content>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                padding: "10px"
              }}
            >
              {/* Title */}
              <h2 style={{ margin: 0, fontWeight: 600 }}>
                Do you want to change the Insured Dob?
              </h2>

              {/* DOB */}
              <div
                style={{
                  background: "#f5f7fa",
                  padding: "10px 15px",
                  borderRadius: "6px",
                  fontSize: "15px",
                  fontWeight: 500
                }}
              >
                Insured DOB: {this.state.qc_insured_dob || "-"}
              </div>

              {/* Buttons */}
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "flex-start"
                }}
              >
                <Button
                  positive
                  style={{
                    minWidth: "80px"
                  }}
                  onClick={this.handleDobChange}
                >
                  Yes
                </Button>

                <Button
                  negative
                  style={{
                    minWidth: "80px"
                  }}
                  onClick={() => this.setState({openDobModal: false, qc_insured_dob: ""})}
                >
                  No
                </Button>
              </div>
            </div>
          </Modal.Content>
        </Modal>
        {allocations}

        <Button
          icon
          labelPosition="left"
          positive
          size="large"
          floated="right"
          disabled={this.disbableSubmitButton()}
          onClick={this.onSubmit}
        >
          <Icon name="check circle" />
          Done - Quality Check
        </Button>
      </Segment>
    );
  }
}


export default (props: any) => {
  return (
    <RequirePermission permission={permissions.Case.check}>
      <ActionQualityCheck {...props} />
    </RequirePermission>
  );
};
